import { useRoutes } from "react-router-dom";
import storage from "../helpers/storage";
import protectRoutes from "./protected";
import publicRoutes from "./public";
import { Navigate } from "react-router-dom";
import { useCustomStore } from "../redux/store";
import { redirectionRoutes } from "./redirectionRoutes";
import { routeRolesPermissions } from "./route-role-permissions";


function AppRoutes() {
    const token = storage.getToken();
    const { user } = useCustomStore();
    const _pRoutes = protectRoutes.map((i: any) => {
        return {...i}
    });
    const redirectTo = () => {
        // Customer
        if(!user?.accessRight) {
            return redirectionRoutes.dashboard.path
        }
        // User
        if(user?.accessRight?.hasAdminAccess || user?.accessRight?.assignRights?.dashboard.read) {
            return redirectionRoutes.dashboard.path
        }else {
            return redirectionRoutes.profile.path
        }
    }

    const commonRoutes = [
        {
            path: '',
            element: <Navigate to={redirectTo()} />
        },
    ]

    const filteredPriateRoutes = routeRolesPermissions(user, _pRoutes);

    const mainRoutes = token ? [...filteredPriateRoutes] : [];
    const routes = useRoutes([...commonRoutes, ...publicRoutes, ...mainRoutes]);
    return (<>{routes}</>);
}

export default AppRoutes;